import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

/**
 * Thrown when a client-side upload request is rejected because the
 * (tenantId, appointmentId) pair does not exist for the caller — typically a
 * 403 or 404 from prepareAppointmentFileUpload. Callers should treat this as
 * terminal: the local file row cannot succeed and should be torn down rather
 * than retried.
 */
export class AppointmentNotAccessibleError extends EluveError {
  static override readonly errorName = 'AppointmentNotAccessibleError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Appointment not accessible', args?: EluveErrorArgs) {
    super(message, args);
  }
}
